<template>
  <div id="app">
    <template v-if="isLogin">
      <Header />
      <Navbar v-if="showMenu" />
    </template>
    <router-view />
  </div>
</template>

<script>
import Header from "./components/Header/index.vue";
import Navbar from "./components/Navbar/index.vue";
export default {
  name: "App",
  components: {
    Header,
    Navbar
  },
  data() {
    return {
      showMenu: true
    };
  },
  created() {
    localStorage.setItem("isLogin", true);
  },
  computed: {
    isLogin() {
      return localStorage.getItem("isLogin") === "true";
    }
  },

  watch: {
    $route: {
      handler(val) {
        ["/xmsb", "/"].includes(val.path)
          ? (this.showMenu = true)
          : (this.showMenu = false);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.flex {
  display: flex;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.double-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
body {
  margin: 0;
  padding: 0;
  background: #f4f7ff;
}
</style>
